<div class="permissions">

  @if (modules.length === 0) {
    <div class="permissions__empty">
      <mat-icon fontSet="material-icons-outlined" aria-hidden="true">lock</mat-icon>
      <p>No modules available for this user group.</p>
    </div>
  }

  <mat-accordion class="permissions__accordion" multi>
    @for (item of modules; track item.id) {
      <mat-expansion-panel class="module-panel" [class.module-panel--off]="!item.hasPermission">
        <mat-expansion-panel-header class="module-panel__header">
          <mat-panel-title class="module-panel__title">
            <mat-icon class="module-panel__icon" fontSet="material-icons-outlined" aria-hidden="true">{{ item.icon }}</mat-icon>
            <span class="module-panel__name">{{ item.name }}</span>
          </mat-panel-title>
          <mat-panel-description class="module-panel__description">
            <span class="module-panel__summary">
              {{ enabledCount(item) }} of {{ item.moduleOptions.length }} enabled
            </span>
            <mat-slide-toggle
              class="module-panel__toggle"
              color="primary"
              [(ngModel)]="item.hasPermission"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              [aria-label]="'Enable module ' + item.name">
            </mat-slide-toggle>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Options area -->
        <div class="options" [class.options--disabled]="!item.hasPermission">

          @if (item.moduleOptions.length === 0) {
            <p class="options__empty">No sub-permissions for this module.</p>
          }

          @if (item.moduleOptions.length > 0) {
            <table class="perm-table" aria-label="Permissions">
              <thead>
                <tr>
                  <th class="perm-table__col-name">Permission</th>
                  <th class="perm-table__col-enable">Enabled</th>
                  <th class="perm-table__col-level">Access level</th>
                </tr>
              </thead>
              <tbody>
                @for (option of item.moduleOptions; track option.moduleOptionId) {
                  <tr class="perm-table__row">
                    <td class="perm-table__name">{{ option.name }}</td>
                    <td class="perm-table__enable">
                      <mat-slide-toggle
                        color="primary"
                        [(ngModel)]="option.hasPermissions"
                        [disabled]="!item.hasPermission"
                        [aria-label]="'Enable ' + option.name">
                      </mat-slide-toggle>
                    </td>
                    <td class="perm-table__level">
                      <mat-button-toggle-group
                        class="access-level"
                        [value]="getLevel(option)"
                        (change)="setLevel(option, $event.value)"
                        [disabled]="!item.hasPermission || !option.hasPermissions"
                        [hideSingleSelectionIndicator]="true"
                        [attr.aria-label]="'Access level for ' + option.name">
                        <mat-button-toggle value="view">
                          <mat-icon fontSet="material-icons-outlined" aria-hidden="true">visibility</mat-icon>
                          View
                        </mat-button-toggle>
                        <mat-button-toggle value="edit">
                          <mat-icon fontSet="material-icons-outlined" aria-hidden="true">edit</mat-icon>
                          Edit
                        </mat-button-toggle>
                      </mat-button-toggle-group>
                    </td>
                  </tr>

                  <!-- Sections (nested rows) -->
                  @if (option.modulesOptionSections.length > 0 && option.hasPermissions) {
                    @for (section of option.modulesOptionSections; track section.optionSectionId) {
                      <tr class="perm-table__row perm-table__row--section">
                        <td class="perm-table__name perm-table__name--section">{{ section.name }}</td>
                        <td class="perm-table__enable">
                          <mat-slide-toggle
                            color="primary"
                            [(ngModel)]="section.hasPermissions"
                            [disabled]="!item.hasPermission || !option.hasPermissions"
                            [aria-label]="'Enable ' + section.name">
                          </mat-slide-toggle>
                        </td>
                        <td class="perm-table__level">
                          <mat-button-toggle-group
                            class="access-level"
                            [value]="getLevel(section)"
                            (change)="setLevel(section, $event.value)"
                            [disabled]="!item.hasPermission || !option.hasPermissions || !section.hasPermissions"
                            [hideSingleSelectionIndicator]="true"
                            [attr.aria-label]="'Access level for ' + section.name">
                            <mat-button-toggle value="view">
                              <mat-icon fontSet="material-icons-outlined" aria-hidden="true">visibility</mat-icon>
                              View
                            </mat-button-toggle>
                            <mat-button-toggle value="edit">
                              <mat-icon fontSet="material-icons-outlined" aria-hidden="true">edit</mat-icon>
                              Edit
                            </mat-button-toggle>
                          </mat-button-toggle-group>
                        </td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
